import {
  GET_FAMILYCONTACT,
  GET_FAMILYCONTACT_SUCCESS,
  GET_FAMILYCONTACT_FAIL,
  DELETE_FAMILYCONTACT,
  DELETE_FAMILYCONTACT_SUCCESS,
  DELETE_FAMILYCONTACT_FAIL,
  UPDATE_FAMILYCONTACT,
  UPDATE_FAMILYCONTACT_SUCCESS,
  UPDATE_FAMILYCONTACT_FAIL,
  ADD_NEW_FAMILYCONTACT,
  ADD_FAMILYCONTACT_SUCCESS,
  ADD_FAMILYCONTACT_FAIL,
  FAMILYCONTACT_LOADING,
  FAMILYCONTACT_RESET,
} from "./actionType";

export const resetFamilyContactState = (actionType) => ({
  type: FAMILYCONTACT_RESET,
  payload: { actionType },
});

export const getFamilyContactSuccess = (actionType, data) => ({
  type: GET_FAMILYCONTACT_SUCCESS,
  payload: { actionType, data },
});

export const getFamilyContactFail = (actionType, error) => ({
  type: GET_FAMILYCONTACT_FAIL,
  payload: { actionType, error },
});

export const getFamilyContact = data => ({
  type: GET_FAMILYCONTACT,
  payload: data,
});

export const getFamilyContactLoading = () => ({
  type: FAMILYCONTACT_LOADING
});

export const deleteFamilyContact = data => ({
  type: DELETE_FAMILYCONTACT,
  payload: data,
});

export const deleteFamilyContactSuccess = data => ({
  type: DELETE_FAMILYCONTACT_SUCCESS,
  payload: data,
});

export const deleteFamilyContactFail = error => ({
  type: DELETE_FAMILYCONTACT_FAIL,
  payload: error,
});

export const updateFamilyContact = data => ({
  type: UPDATE_FAMILYCONTACT,
  payload: data,
});

export const updateFamilyContactFail = error => ({
  type: UPDATE_FAMILYCONTACT_FAIL,
  payload: error,
});

export const updateFamilyContactSuccess = data => ({
  type: UPDATE_FAMILYCONTACT_SUCCESS,
  payload: data,
});

export const addNewFamilyContact = data => ({
  type: ADD_NEW_FAMILYCONTACT,
  payload: data,
});

export const addFamilyContactSuccess = data => ({
  type: ADD_FAMILYCONTACT_SUCCESS,
  payload: data,
});

export const addFamilyContactFail = error => ({
  type: ADD_FAMILYCONTACT_FAIL,
  payload: error,
});